import { render } from "./ContributeText.vue?vue&type=template&id=51226213&scoped=true"
import script from "./ContributeText.vue?vue&type=script&lang=js"
export * from "./ContributeText.vue?vue&type=script&lang=js"

import "./ContributeText.vue?vue&type=style&index=0&id=51226213&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-51226213"

export default script